<template>
  <div class="n_expressage">
    <div class="n_card">
      <div class="nm_goods">
        <p class="n_goodsName">商品信息</p>
        <div class="flex n_content">
          <img :src="child_order_list.goods_image" alt />
          <div class="n_goodscontent">
            <p class="n_name">{{child_order_list.goods_name}}</p>
            <div class="flex space_beetw">
              <p>{{child_order_list.specification}}</p>
              <p>数量：{{child_order_list.num}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="nm_goods n_marginTop">
        <van-field v-model="from.ship_sn" label="物流单号" placeholder="请填写物流单号" input-align="right" />
        <van-field v-model="from.ship_name" label="物流公司" placeholder="请填写物流公司" input-align="right" />
        <!-- <van-field
          v-model="from.send_back_name"
          label="联系电话"
          placeholder="请填写联系电话"
          input-align="right"
        />-->
        <van-field
          v-model="from.ship_notes"
          label="申请原因"
          placeholder="申请原因(选填)"
          input-align="right"
        />
        <div class="n_uploadimg">
          <p class="n_oimg n_marginTop">
            上传凭证
            <span style="marginLeft:10px">选填</span>
          </p>
          <van-uploader
            class="n_imgList"
            :after-read="afterRead"
            v-model="fileList"
            multiple
            :max-count="6"
          />
        </div>
      </div>
      <van-button type="danger" class="n_btn" @click="submitFg">提交</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {
      fileList: [],
      from: {},
      child_order_list: {},
      orderSn: '',
    }
  },
  created() {
    this.orderSn = this.$route.query.orderSn
    this.getOrderDetail()
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    afterRead() {},
    //获取订单详情
    getOrderDetail() {
      this.http('ClientOrder.refundApplyDetail', {
        order_detail_id: this.$route.query.orderDetailId,
        apply_sn: this.$route.query.sn,
      }).then((res) => {
        if (res.status == 200) {
          console.log(res)
          this.child_order_list = res.content
        } else {
          Toast(res.msg)
        }
      })
    },
    async submitFg() {
      this.from.apply_sn = this.$route.query.sn
      let res = await this.http('ClientOrder.completeExpress', { ...this.from })
      console.log(res)
      if (res.status == 200) {
        Toast('填写物流信息成功')
        this.$router.go(-1)
      } else {
        Toast(res.msg)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.n_expressage {
  min-height: 100vh;
  background: #f0f2f5;
}
.n_card {
  padding: 20px;
}
.nm_goods {
  padding: 36px 102px 50px 40px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
}
.n_goodsName {
  font-size: 30px;
  font-weight: bold;
  color: #333333;
}
.n_content {
  margin-top: 70px;
}
.n_content img {
  display: block;
  width: 120px;
  height: 120px;
  background: #f4f6f8;
  border-radius: 10px;
}
.n_goodscontent {
  margin-left: 22px;
}
.n_name {
  font-size: 26px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.space_beetw {
  justify-content: space-between;
}
.space_beetw p {
  font-size: 24px;
  color: #999999;
  margin-top: 30px;
}
.n_marginTop {
  margin-top: 20px;
}
.n_oimg {
  font-size: 26px;
  color: #999999;
}
.n_imgList {
  margin-top: 20px;
}
.n_btn {
  width: 600px;
  height: 100px;
  background: #ff9f9f linear-gradient(184deg, #ff3333 0%, #ff5720 100%);
  border-radius: 10px;
  margin: 50px;
}
</style>